export const centered = {
  textAlign: 'center',
  alignItems: 'center',
} as const;
